import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GridColumn } from '@grid/abstractions';

@Component({
  standalone: false,
  selector: 'gstar-prime-grid-header',
  templateUrl: './prime-grid-header.component.html',
  styleUrls: ['./prime-grid-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrimeGridHeaderComponent {
  @Input() header!: GridColumn;
}
